import { FC } from 'react';
import { Control, useController } from 'react-hook-form';

import { ChevronDownIcon } from '../../../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../../../components/app-formatted-message/index';
import {
  ComboboxButton,
  ComboboxOptions,
  FormCombobox,
  FormComboboxInput,
  FormComboboxOption,
} from '../../../../../../components/combobox/index';
import { useLocale } from '../../../../../../hooks/index';
import { documentCategoryOptions } from '../../../../constants/document-category.constant';
import { QuickSignFormSchema } from '../../../validation/quick-sign.validation';

export type CategoryComboboxProps = {
  control: Control<QuickSignFormSchema>;
  disabled?: boolean;
};

export const CategoryCombobox: FC<CategoryComboboxProps> = ({ control, disabled = false }) => {
  const { messagesLocale } = useLocale();
  const { field } = useController({ control, name: 'stepOne.category' });

  const selectedOption = documentCategoryOptions.find((o) => o.value === field.value);
  const displayValue = selectedOption ? messagesLocale[selectedOption.labelKey] : '';

  return (
    <FormCombobox className="relative" control={control} name="stepOne.category">
      <div className="relative">
        <FormComboboxInput
          control={control}
          customValue={() => displayValue}
          disabled={disabled}
          icon={<ChevronDownIcon className="mt-3 h-4 w-4 text-gray-500" />}
          name="stepOne.category"
          placeholder={<AppFormattedMessage id="CATEGORY" />}
          readOnly
          wrapperClassName="min-h-[56px]"
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" disabled={disabled} />
      </div>
      <ComboboxOptions className="absolute z-20 w-full rounded border border-gray-200 bg-white p-2 shadow-lg">
        {documentCategoryOptions.map(({ value, labelKey }) => (
          <FormComboboxOption control={control} key={value} name="stepOne.category" value={value}>
            <span className="text-sm font-normal text-gray-700">
              <AppFormattedMessage id={labelKey} />
            </span>
          </FormComboboxOption>
        ))}
      </ComboboxOptions>
    </FormCombobox>
  );
};
